import * as R from 'ramda';

export default function PerformBusinessImpactAnalysisDialogController(
  $filter,
  $rootScope,
  $q,
  $timeout,
  alerts,
  ssDialogService,
  loaderService,
  bcpDataService
) {
  const vm = this;

  vm.activeProcess = vm.processes[0] || {};
  vm.canSeeSubmit = vm.activeProcess.showEditImpactInformation;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleNavToProcess = _handleNavToProcess;
  vm.handlePerformImpactAnalysisFormSubmit = _handlePerformImpactAnalysisFormSubmit;
  vm.validateActiveProcess = _validateActiveProcess;

  _activate();

  /** *********************************
   * Event Handlers
   */

  function _activate() {
    _setActiveProcessFunctionNames();
    _triggerGraphReRender();
    loaderService.showViewLoader = false;
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.performBusinessImpactAnalysisDialog);
  }

  function _handleNavToProcess(processId) {
    const newActiveProcess = $filter('filter')(vm.processes, { processId, }, true)[0];
    if (vm.activeProcess !== newActiveProcess) {
      vm.contentPaneIsFaded = true;
      $timeout(
        () => {
          vm.activeProcess = newActiveProcess;
          vm.canSeeSubmit = vm.activeProcess.showEditImpactInformation;
          _setActiveProcessFunctionNames();
          _triggerGraphReRender();
          _triggerSetMaxMadValues();
          vm.contentPaneIsFaded = false;
          _resetContentPaneScroll();
          // vm.activeProcess.maximumAcceptableDowntime = vm.activeProcess.maximumAcceptableDowntime;
        },
        100
      );
    }
  }

  function _handlePerformImpactAnalysisFormSubmit() {
    loaderService.showViewLoader = true;
    _saveImpactAnalysis().then(
      // Success
      () => {
        const processesToSubmit = $filter('filter')(
          vm.processes, { readyToSubmit: true }
        );

        const processIdsToSubmit = [];

        if (processesToSubmit.length > 0) {
          angular.forEach(processesToSubmit, (process) => {
            processIdsToSubmit.push(process.assessmentProcessId);
          });

          bcpDataService.submitAssessmentProcesses(processIdsToSubmit).then(
            () => {
              // Success
              alerts.success('The BCP Business Impact Analysis has been saved and submitted successfully.');
              $rootScope.$broadcast('refreshBCPAssessments');
              $rootScope.$broadcast('refreshNotifications');
              loaderService.showViewLoader = false;
            },
            () => {
              // Failure
              alerts.error('There was an error submitting the BCP Business Impact Analysis Processes.');
              loaderService.showViewLoader = false;
            }
          );
        } else {
          alerts.success('The BCP Business Impact Analysis has been saved successfully.');
          $rootScope.$broadcast('refreshBCPAssessments');
          $rootScope.$broadcast('refreshNotifications');
          loaderService.showViewLoader = false;
        }
        if (vm.saveType === 'saveAndClose') {
          ssDialogService.hide(ssDialogService.dialogs.bcp.performBusinessImpactAnalysisDialog);
        } else {
          vm.processes = vm.processes.filter(process => !process.readyToSubmit);
          if ((vm.activeProcess.readyToSubmit) && (vm.processes) && (vm.processes.length > 0)) {
            loaderService.showViewLoader = false;
            _handleNavToProcess(vm.processes[0].processId);
          } else {
            $rootScope.$broadcast('refreshBCPAssessments');
            $rootScope.$broadcast('refreshNotifications');
            loaderService.showViewLoader = false;
          }
        }
      },
      // Fail
      () => {
        loaderService.showViewLoader = false;
        alerts.error('There was an error saving the BCP Business Impact Analysis.');
      }
    );
  }

  function _validateActiveProcess() {
    // RTO >= MAD shouldn't ever happen because the UI controls should prevent it.
    // But the Material Design slider is somewhat buggy, so we check just in case.
    if (vm.activeProcess.recoveryTimeObjective >= vm.activeProcess.maximumAcceptableDowntime) {
      vm.activeProcess.readyToSubmit = false;
      alerts.error('The Recovery Time Objective can\'t exceed the Maximum Acceptable Downtime.');
    }
  }

  /** *********************************
   * Private Functions
   */

  function _setActiveProcessFunctionNames() {
    let _activeProcessFunctionNameList = '';
    if ((vm.activeProcess.assessmentFunctions !== null) && (vm.activeProcess.assessmentFunctions.length > 0)) {
      const _sortedFunctions = R.sortBy(R.prop('name'), vm.activeProcess.assessmentFunctions);
      angular.forEach(_sortedFunctions, (assessmentFunction) => {
        if (_activeProcessFunctionNameList === '') {
          _activeProcessFunctionNameList = assessmentFunction.name;
        } else {
          _activeProcessFunctionNameList = `${_activeProcessFunctionNameList}, ${assessmentFunction.name}`;
        }
      });
    }

    vm.activeProcess.activeProcessFunctionNameList = _activeProcessFunctionNameList;
  }

  function _triggerGraphReRender() {
    $timeout(() => {
      $rootScope.$broadcast('reRenderImpactAnalysisGraph', { processId: vm.activeProcess.processId });
    }, 20);
  }

  function _triggerSetMaxMadValues() {
    $timeout(() => { $rootScope.$broadcast('setMaxMadValues'); }, 20);
  }

  function _resetContentPaneScroll() {
    $timeout(
      () => {
        angular.forEach(
          angular.element('.bcp--perform-impact-analysis-content-pane'),
          (element) => {
            angular.element(element)[0].scrollTop = 0;
          }
        );
        // This is a hacky fix for the md-sliders not properly matching the model because of transition
        const tempRto = vm.activeProcess.recoveryTimeObjective;
        vm.activeProcess.recoveryTimeObjective = 0;
        $timeout(() => { vm.activeProcess.recoveryTimeObjective = tempRto; }, 0);
      },
      50
    );
  }

  function _saveImpactAnalysis() {
    return bcpDataService.saveAssessmentProcesses(vm.assessmentId, vm.processes);
  }
}

PerformBusinessImpactAnalysisDialogController.$inject = [
  '$filter',
  '$rootScope',
  '$q',
  '$timeout',
  'alerts',
  'ssDialogService',
  'loaderService',
  'bcpDataService'
];
